module.exports = __webpack_public_path__ + "static/media/sanfield-logo.b57db654.png";